import { render } from "./InstructorQuickUpdate.vue?vue&type=template&id=63851ee0&scoped=true"
import script from "./InstructorQuickUpdate.vue?vue&type=script&lang=js"
export * from "./InstructorQuickUpdate.vue?vue&type=script&lang=js"

import "./InstructorQuickUpdate.vue?vue&type=style&index=0&id=63851ee0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63851ee0"]])

export default __exports__